import section9 from "./chairs-with-screen-in-front.jpg";
import section8 from "./man-is-holding-a-presentation.jpg";
import section7 from "./man-surrounded-by-sitting-people.jpg";
import header from "./multiple-rows-of-chairs.jpg";
import section1 from "./seating-arrangement.webp";
import section5 from "./several-people-talking-on-meeting.jpg";
import section4 from "./stuhlreihen.jpg";
import section6 from "./table-surrounded-with-chairs.jpg";
import section3 from "./tables-with-chairs.jpg";
import section2 from "./woman-is-holding-a-presentation.jpg";

export {
  header,
  section1,
  section2,
  section3,
  section4,
  section5,
  section6,
  section7,
  section8,
  section9,
};
